export default class Club {
    constructor(club, shortClub, contact, phone, address, mail) {
        this.club = club;
        this.shortClub = shortClub;
        this.contact = contact;
        this.phone = phone;
        this.address = address;
        this.mail = mail;
    }
}